<script>
/**
 * Imports a component dynamically and exposes it in the default `v-slot`
 */
export default {
    name: 'DynamicComponent',
    props: {
        /**
         * Component name which should be located in `common/components/dynamic` folder
         */
        name: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            loading: true,
            error: null,
            component: null,
        };
    },
    created() {
        if (!this.name) {
            this.loading = false;

            return;
        }

        import(/* webpackChunkName: "[request]-vue" */ `@v4/common/components/dynamic/${this.name}`)
            .then(({ default: Component }) => {
                this.component = Component;
            })
            .catch((error) => {
                this.error = error;
            })
            .finally(() => {
                this.loading = false;
            });
    },
    render(h) {
        if (!this.$scopedSlots.default) {
            return;
        }

        return h(
            'div',
            { class: 'dynamic-component' },
            /**
             * @slot Default content
             * @binding {boolean} loading Whether is loading or not
             * @binding {object} error Error response
             * @binding {object} component Component object
             */
            this.$scopedSlots.default({ loading: this.loading, error: this.error, component: this.component })
        );
    },
};
</script>
